import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonPrimaryComponent, GpSpinnerController, NotificationService, StateService } from "@geolib/geoappbase-client";
import { TranslatePipe } from "@ngx-translate/core";
import { BreadcrumbComponent } from "../breadcrumb/breadcrumb.component";
import { AutofocusDirective } from "../common/Autofocus";
import { isNumber } from "../common/IsNumber";
import ITopic from "./ITopic";
import { TopicService } from "./TopicService";


@Component({
    selector: "topic-edit",
    templateUrl: "./topic-edit.html",
    imports: [
        BreadcrumbComponent,
        FormsModule,
        AutofocusDirective,
        TranslatePipe,
        ButtonPrimaryComponent,
        GpSpinnerController,
    ],
})
export default class TopicEditController {

    public topic: ITopic;
    public errorMessage: string = "";

    public constructor(
        private readonly stateService: StateService,
        private readonly topicService: TopicService,
        private readonly notificationService: NotificationService,
    ) {
        const id = stateService.getParameter("id");
        this.topicService.findOne(id ? id : "create").subscribe((topic) => {
            this.topic = topic;
        }, () => {
            this.errorMessage = "TOPIC_EDIT.LOADING_FAILED";
        });
    }

    public save(): void {
        if (isNumber(this.topic.id)) {
            delete this.topic.id;
        }

        this.topicService.save(this.topic).subscribe(() => {
            this.notificationService.notify("SYSTEM.DEFAULT_SAVE_SUCCESS");
            this.abort();
        }, () => {
            this.notificationService.error("SYSTEM.DEFAULT_SAVE_ERROR");
        });
    }

    public abort(): void {
        this.stateService.go("app.topics.list");
    }

}
